interface IHotelRoomStatuses {
  onSale: string;
  saleStopped: string;
  deleted: string;
}

export const HotelRoomStatuses: IHotelRoomStatuses = {
  onSale: "on_sale",
  saleStopped: "sale_stopped",
  deleted: "deleted",
};
